module.exports = __webpack_public_path__ + "static/media/cs2cover.810f0d16.jpg";